export { default } from './Icon'

export { InterfaceIcons, TopicIcons, GeneralIcons, SocialIcons, TablerIcons } from './Icon.const'
